import React from 'react'
import { useTable, useSortBy } from 'react-table'
import { callback } from '../../helpers.js';


export default (props) => {
	const { columns, data } = props;
	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		rows,
		prepareRow,
	} = useTable(
		{
		columns,
		data,
		},
		useSortBy
	)

	const onClick = (e, i, d) => {
		e.preventDefault();
		callback(props.onClick, [d.original]); // d.values
	}


	return (
		<>
		<table {...getTableProps()} className="Table data-table">
			<thead>
			{headerGroups.map(headerGroup => (
				<tr {...headerGroup.getHeaderGroupProps()}>
				{headerGroup.headers.map(column => (
					// Add the sorting props to control sorting. For this example
					// we can add them into the header props
					<th {...column.getHeaderProps(column.getSortByToggleProps())}>
					{column.render('Header')}
					{/* Add a sort direction indicator */}
					<span>
						{column.isSorted
						? column.isSortedDesc
							? ' 🔽'
							: ' 🔼'
						: ''}
					</span>
					</th>
				))}
				</tr>
			))}
			</thead>
			<tbody {...getTableBodyProps()}>
			{rows.map(
				(row, i) => {
				prepareRow(row);
				return (
					<tr {...row.getRowProps()} onClick={(e)=>onClick(e,i,row)} data-index={i}>
					{row.cells.map(cell => {
						return (
						<td {...cell.getCellProps()}>{cell.render('Cell')}</td>
						)
					})}
					</tr>
				)}
			)}
		</tbody>
		</table>
		</>
	)
}